import React from 'react';
import { DictionaryTypes } from '../olonkho-constants';
import { DICTIONARY } from '../olonkho-dictionary';
import { View, FlatList } from 'react-native';
import OButton, { OSearchButton } from '../olonkho-fw';
import { oStyles } from '../olonkho-styles';

export default function Dictionary({ navigation }) {
    return (
        <View style={ oStyles.dictionary_page_container }>
            <OSearchButton 
                title={ "Расширенный поиск" }
                onPress={ () => navigation.navigate('AdvancedSearch') }
            />
            <FlatList 
                data={ DictionaryTypes }
                renderItem={ (item) => {
                    return (
                        <OButton 
                            title={ item.item.title } 
                            onPress={ () => {
                                navigation.navigate('DictionaryPage', { items: DICTIONARY.filter((d) => d.type === item.item.id) });
                            } }
                        />
                    );
                } }
            />
        </View>
      );
}